import script from "./tasps.vue?vue&type=script&setup=true&lang=js"
export * from "./tasps.vue?vue&type=script&setup=true&lang=js"

import "./tasps.vue?vue&type=style&index=0&id=054cab80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054cab80"]])

export default __exports__